module.exports = __webpack_public_path__ + "static/media/sub_invoice_template.2dd7ecce.docx";